// extracted by mini-css-extract-plugin
module.exports = {"titleBox":"App_titleBox__YGdX7","title":"App_title__-GfWs","floatbox":"App_floatbox__wNM_K","float":"App_float__2VErm"};